import * as React from "react";
import { Namespace, useTypedT } from "@racoon/i18n";
import { IcPlus } from "@racoon/icons";
import { Button } from "@racoon/ui";
import { ConnectProto } from "@racoon/api";
import { useActiveDriverOptions } from "~/shared/api/user/use-active-driver-options";
import { useAuthSession } from "~/shared/hooks/auth.session.admin";
import { CreateShiftModal } from "../../../autopark/components/CreateShiftModal";

type Props = {
  shift: ConnectProto.DriverOnShift;
  truck: ConnectProto.Truck;
};

/**
 * Opens the change-driver modal on a shift planned without a driver. A planned
 * shift is updated in place, so the open tab keeps its routes; the shift list
 * refreshes through the mutation's cache tags.
 */
export const AssignShiftDriverButton: React.FC<Props> = ({ shift, truck }) => {
  const t = useTypedT(Namespace.Routes);
  const { activeCompanyId } = useAuthSession();

  const drivers = useActiveDriverOptions(activeCompanyId);

  return (
    <CreateShiftModal
      truckId={String(truck.id)}
      trucks={[truck]}
      drivers={drivers}
      activeShiftId={shift.id}
      activeShiftStatus={shift.status}
      planStart={shift.twStartAt}
      trigger={
        <Button
          id={`msw-route-list-assign-driver-${shift.id}-button`}
          size="sm"
          className="gap-2 text-sm"
        >
          <IcPlus className="h-4 w-4 shrink-0" />
          {t("assignDriverToShift")}
        </Button>
      }
    />
  );
};
